import { useWebUserContext } from "contexts";
import { useState } from "react";

export type VideoCallParticipant = {
  email: string;
  displayedName?: string;
  isRemovable?: boolean;
}

type VideoCallParticipantsHookOutput = {
  participants: VideoCallParticipant[];
  addParticipant: (participant: string) => void;
  removeParticipant: (participant: string) => void;
};

const useVideoCallParticipants = (): VideoCallParticipantsHookOutput => {
  const { webUser } = useWebUserContext();
  const [participants, setParticipants] = useState<VideoCallParticipant[]>([
    { email: webUser.email, displayedName: 'Vous', isRemovable: false },
  ]);

  const addParticipant = (newParticipant: string): void => {
    if (!participants.find(participant => participant.email === newParticipant)) {
      setParticipants([...participants, {email: newParticipant, isRemovable: true}]);
    }
  };

  const removeParticipant = (participantNameToRemove: string): void => {
    const newParticipants = participants.filter(participant => !participant.isRemovable || participant.email !== participantNameToRemove);
    setParticipants(newParticipants);
  };

  return { participants, addParticipant, removeParticipant };
};

export default useVideoCallParticipants;